export default {"src":"/_next/static/media/smava-wunschkredit.b00e2447.svg","height":25,"width":92,"blurWidth":0,"blurHeight":0};